import {Button, Modal} from 'letrus-ui';
import styles from './FinishModal.module.scss';

export interface FinishModalProps {
  id: string;
  onCloseModal(): void;
  onFinishConfirm(): void;
}

function FinishModal({id, onCloseModal, onFinishConfirm}: FinishModalProps) {
  return (
    <Modal id={id} className={styles.modal} childClassName={styles.wrapper}>
      <div className={styles.text}>
        <h1>
          Pense bem! <span className={styles.emoji}>🧐</span>
        </h1>
        <p>
          Ao salvar você não poderá mais incluir ou excluir marcações. Deseja
          continuar?
        </p>
      </div>
      <div className={styles.buttons}>
        <Button variant="secondary" onClick={onCloseModal}>
          Voltar
        </Button>
        <Button
          variant="primary"
          onClick={onFinishConfirm}
          data-testid="finish-button"
        >
          Continuar
        </Button>
      </div>
    </Modal>
  );
}

export default FinishModal;
